export default __webpack_public_path__ + "static/media/DropDown.681f8c63.svg";